import { SelectedContinent } from 'components/modals/frontend/Destinations/DestinationModalContinentList'
import { isServer } from 'data/helpers/ssr'
import { graphql } from 'gql'
import { DestinationCountryOrderByColumn, SortOrder } from 'gql/graphql'
import { useState } from 'react'
import { useQuery } from 'urql'

const COUNTRY_DETAILS_QUERY = graphql(`
  query DestinationsModalCountryDetails(
    $country_id: ID,
  ) {
    country (id: $country_id) {
      id
      value
      slug
      regions (first: 100, filters: { onlyPublished: true }) {
        data {
          id
          value
          slug
          subRegions (filters: { onlyPublished: true }) {
            id
            value
            slug
          }
        }
      }
      random_region {
        id
        main_media {
          id
          url
          file_name
        }
      }
      property_count
    }
  }
`)

const ALL_DATA_QUERY = graphql(`
  query DestinationsModalDetails(
    $randomRegionFilters: RandomRegionFiltersInput,
    $countryFilters: CountriesFilterInput,
    $orderBy: [OrderByClause!]
  ) {
    countries (first: 100, orderBy: $orderBy, filters: $countryFilters) {
      data {
        id
        value
        slug
        regions (first: 100, filters: { onlyPublished: true }) {
          data {
            id
            value
            slug
          }
        }
      }
    }

    propertyCount

    randomRegion (filters: $randomRegionFilters) {
      id
      main_media {
        id
        url
        file_name
      }
    }
  }
`)

export const useDestinationQuery = (isOpen: boolean) => {
  const [countryId, setCountryId] = useState<string | null>(null)
  const [selectedContinent, setSelectedContinent] = useState<SelectedContinent | null>(null)

  const [{ data: countryData, fetching: fetchingCountry }] = useQuery({
    query: COUNTRY_DETAILS_QUERY,
    variables: {
      country_id: countryId,
    },
    pause: !isOpen || !countryId || isServer,
  })

  const [{ data: allData, fetching: fetchingAll }] = useQuery({
    query: ALL_DATA_QUERY,
    variables: {
      randomRegionFilters: {
        country_ids: countryId ? [countryId] : null,
        continent_id: selectedContinent?.id,
      },
      countryFilters: { continent_id: selectedContinent?.id, onlyPublished: true },
      orderBy: [{
        column: DestinationCountryOrderByColumn.Value,
        order: SortOrder.Asc,
      }],
    },
    pause: !!(!isOpen && countryId && isServer && selectedContinent),
  })

  return {
    selectedContinent,
    setSelectedContinent,
    countryId,
    setCountryId,
    dataType: countryId ? 'country' : 'all' as 'country' | 'all',
    data: countryId ? countryData : allData,
    fetching: fetchingCountry || fetchingAll,
  }
}
